import { gql } from "@apollo/client";

export const DELETE_CONTACT_MUTATION = gql`
  mutation DeleteContact($_id: String!) {
    deleteContact(_id: $_id)
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($email: String!) {
    emailPasswordReset(email: $email)
  }
`;

export const LOGIN_CONTACT_MUTATION = gql`
  mutation LoginContact($email: String!, $password: String!) {
    loginContact(email: $email, password: $password) {
      token
      contact {
        _id
        name
        email
        address1
        address2
        city
        state
        zip
        id
        customer_id
        require_password_change
        role
      }
    }
  }
`;

export const UPDATE_CONTACT_MUTATION = gql`
  mutation UpdateContact(
    $_id: String!
    $email: String
    $password: String
    $name: String
    $address1: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $role: String
  ) {
    updateContact(
      _id: $_id
      email: $email
      password: $password
      name: $name
      address1: $address1
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      role: $role
    ) {
      _id
      name
      email
      address1
      address2
      city
      state
      zip
      id
      customer_id
      require_password_change
      role
    }
  }
`;

export const CREATE_CONTACT_MUTATION = gql`
  mutation CreateContact(
    $email: String!
    $password: String
    $name: String!
    $address1: String!
    $address2: String
    $city: String!
    $state: String!
    $zip: String!
    $role: String!
    $customer_id: Int!
  ) {
    createContact(
      email: $email
      password: $password
      name: $name
      address1: $address1
      address2: $address2
      city: $city
      state: $state
      zip: $zip
      role: $role
      customer_id: $customer_id
    ) {
      name
      email
      address1
      address2
      city
      state
      zip
      id
      customer_id
      require_password_change
      role
    }
  }
`;
